import DisconnectIcon from '@/assets/icons/disconnect.svg?react';
import { IconButton } from '@/lib';
import { Audience } from '@/models/audiences';
import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { FC, useReducer } from 'react';
import { DisconnectFlowInstanceModal } from './modals/DisconnectFlowInstanceModal';

type AudienceFlowInstanceDisconnectButtonProps = {
  audience: Audience;
  flowInstance: ConnectorFlowInstanceDTO;
};

export const AudienceFlowInstanceDisconnectButton: FC<AudienceFlowInstanceDisconnectButtonProps> = ({ audience, flowInstance }) => {
  const [isModalOpen, toggleModal] = useReducer((state) => !state, false);

  return (
    <>
      <IconButton
        intent='link-grey'
        className='!p-1.5 text-tertiary-600'
        leadingIcon={<DisconnectIcon className='text-quaternary-400' />}
        onClick={toggleModal}
      />
      {isModalOpen && <DisconnectFlowInstanceModal audience={audience} flowInstance={flowInstance} closeModal={toggleModal} />}
    </>
  );
};
